import * as Yup from 'yup';

const emailRegex = /@victronenergy\.com$/;

const EMAIL_VALIDATION_MESSAGE = 'Please make sure to use your @victronenergy.com email address.';
const EMAIL_REQUIRED_MESSAGE = 'Email is required.';
const COUNTRY_VALIDATION_MESSAGE = 'Please select at least one country.';

export const InboxSchema = Yup.object({
    email: Yup.string().matches(emailRegex, EMAIL_VALIDATION_MESSAGE).required(EMAIL_REQUIRED_MESSAGE),
    country_codes: Yup.array()
        .of(Yup.string().required())
        .min(1, COUNTRY_VALIDATION_MESSAGE)
        .required(COUNTRY_VALIDATION_MESSAGE),
    notes: Yup.string(),
});
